import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Button } from 'components'
import { useNavigate } from 'react-router-dom'


const DataNoneIntro = () => {

	const App = useApp()
	const navigate = useNavigate()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	const ongoMydata = () => {
		navigate("/data", {state: {from: "/home/dataNoneIntro"}})
	}

	return (
		<div className="page">
			<div className="flex_ 1 padding center-cont">
				<i className="icon icon_report_intro" />
				<h3 className="intro-tit mt_20">아직 연결한 정보가 없네요.</h3>
				<p className="intro-sub-tit mt_10">마이데이터를 연결하면<br />
					나의 데이터를 지인에게 공유할 수 있어요!<br />
					지금 연결해볼까요?
				</p>
			</div>
			<div className="padding flex-shrink_0" onClick={()=> ongoMydata()}>
				<Button className="btn btn--big">마이데이터 연결하기</Button>
			</div>
		</div>
	)
}

export default DataNoneIntro
